/**
 * Product gallery
 * ------------------------------------------------------------------------------
 * An Product gallery file that contains scripts to function
 *
 * @namespace productGallery
 */

import Carousel from './carousel';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-product-gallery="container"]',
  featuredImage: '[js-product-gallery="featuredImage"]',
  featuredCarousel: '[js-product-gallery="featuredCarousel"]',

  containerNav: '[js-product-gallery="containerNav"]',
  featuredImageNav: '[js-product-gallery="featuredImageNav"]',
  featuredCarouselNav: '[js-product-gallery="featuredCarouselNav"]',
};

/**
 * Instance globals.
 */
let featuredCarousel = {};
let featuredCarouselNav = {};

/**
 * Initialise component.
 */
function init() {
  // setDefaultState();
}

/**
 * Construct carousel objects on gallery images.
 */
function constructCarousels() {
  featuredCarousel = new Carousel(selectors.featuredCarousel, {
    cellSelector: selectors.featuredImage,
    prevNextButtons: true,
    pageDots: true,
  });
  featuredCarousel.init();

  featuredCarouselNav = new Carousel(selectors.featuredCarouselNav, {
    asNavFor: selectors.featuredCarousel,
    cellSelector: selectors.featuredImageNav,
    prevNextButtons: true,
    draggable: false,
    contain: true,
    pageDots: true,
    wrapAround: false,
    groupCells: 4,
  });

  featuredCarouselNav.init();
}

/**
 * Set default state based on screen size.
 */
function setDefaultState() {
  constructCarousels();
  // handleResizeEvent();
}

/**
 * Export a new product gallery.
 */
export default () => {

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};

